<template>
  <v-layout row wrap ma-0 justify-space-between>
    <v-flex xs12>
      <v-layout class="mt-4" row wrap ma-0>
        <v-flex xs12 order-0 sm6 order-sm-0 pr-sm-4 md4 order-md-0 pr-md-4>
          <v-card class="card" v-for="(summary, i) in summaryReport" :key="i">
            <v-card-title class="v-card-title">{{ summary.name }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="v-card-text" v-for="(report, j) in summary.data" :key="j">
              <v-list-item  v-if="report.subheader" class="item">
                <v-list-item-content><b><u>{{ report.text }}</u></b></v-list-item-content>
              </v-list-item>
              <v-list-item v-else class="item cursor" @click="openDialog(report)">
                <v-list-item-content :class="{ 'pl-2' : report.indent }">{{ report.name }}</v-list-item-content>
                <v-icon color="#BA4438">keyboard_arrow_right</v-icon>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 order-1 sm6 order-sm-2 pr-sm-4 md4 order-md-1 px-md-4>
          <v-card class="card" v-for="(range, i) in rangeReport" :key="i">
            <v-card-title
              class="v-card-title"
              :class="{ cursor: range.link != null }"
              @click="Gotopage(range.link)"
            >
              {{ range.name }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="v-card-text" v-for="(report, j) in range.data" :key="j">
              <v-list-item  v-if="report.subheader" class="item">
                <v-list-item-content><b><u>{{ report.text }}</u></b></v-list-item-content>
              </v-list-item>
              <v-list-item v-else class="item cursor" @click="openDialog(report)">
                <v-list-item-content :class="{ 'pl-2' : report.indent }">{{ report.name }}</v-list-item-content>
                <v-icon color="#BA4438">keyboard_arrow_right</v-icon>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 order-2 sm6 order-sm-1 pl-sm-4 md4 order-md-2 pl-md-4>
          <v-card class="card" v-for="(other, i) in otherReport" :key="i">
            <v-card-title class="v-card-title">{{ other.name }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="v-card-text" v-for="(report, j) in other.data" :key="j">
              <v-list-item  v-if="report.subheader" class="item">
                <v-list-item-content><b><u>{{ report.text }}</u></b></v-list-item-content>
              </v-list-item>
              <v-list-item v-else class="item cursor" @click="openDialog(report)">
                <v-list-item-content :class="{ 'pl-2' : report.indent }">{{ report.name }}</v-list-item-content>
                <v-icon color="#BA4438">keyboard_arrow_right</v-icon>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog v-model="dialog" persistent width="540">
      <v-card class="pt-4">
        <v-tabs hide-slider fixed-tabs>
          <!--v-tab class="ml-4" href="#tabSeason" @click="searchType = 'tabSeason'">
            ช่วงเทศกาล
          </v-tab>
          <v-tab class="mr-4" href="#tabPeriod" @click="searchType = 'tabPeriod'">ช่วงเวลา</v-tab-->
          <v-tab href="#tabPeriod" @click="searchType = 'tabPeriod'">ช่วงเวลา</v-tab>

          <v-tab-item value="tabSeason" class="px-5 pt-5 pb-5">
            <v-layout row wrap ma-0 mt-4>
              <v-flex xs12>
                <v-layout column wrap ma-0>
                  <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']" v-show="isYear">
                    <p class="font-weight-medium my-0">ปี พ.ศ.</p>
                    <v-select
                      v-model="yearSelect"
                      :items="yearItems"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกปี"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 mt-2']"
                    v-show="isEvent"
                  >
                    <p class="font-weight-medium my-0">เทศกาล</p>
                    <v-select
                      v-model="eventSelect"
                      :items="eventItems"
                      item-text="name"
                      :return-object="true"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกเทศกาล"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 mt-2']"
                    v-show="isDepartment"
                  >
                    <p class="font-weight-medium my-0">หน่วยงาน</p>
                    <v-select
                      v-model="departmentSelect"
                      :items="departmentItems"
                      item-text="description"
                      item-value="id"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกหน่วยงาน"
                      class="card-border"
                      flat
                      solo
                      :chips="departmentMultiple"
                      hide-details
                      :multiple="departmentMultiple"
                    >
                      <template v-slot:selection="{ item }" v-if="departmentMultiple">
                        <v-chip>
                          <span>{{ item.name_th }}</span>
                        </v-chip>
                        <!-- <spanf
                  v-if="index === 1"
                  class="grey--text caption"
                >(และอื่นๆ อีก {{ departmentSelect.length - 1 }} รายการ)</spanf> -->
                      </template>
                      <template v-slot:prepend-item v-if="departmentMultiple">
                        <v-list-item ripple @click="toggleSelectAllDepartment">
                          <v-list-item-action>
                            <v-icon :color="departmentSelect.length > 0 ? 'primary base' : ''">{{
                              departmentSelecticon
                            }}</v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>เลือกทั้งหมด</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item value="tabPeriod" class="px-5 pt-5 pb-5">
            <v-layout row wrap ma-0>
              <v-flex xs12>
                <v-layout column wrap ma-0>
                  <v-flex
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isStartDate"
                  >
                    <p class="font-weight-medium my-0">วันที่เริ่มต้น</p>
                    <DatePicker
                      v-model="startDate"
                      ref="startDate"
                      :max="today"
                      @input="changeDate(utils.startDateChanged(startDate, endDate))"
                      :defaultDate="eventSelect.start_date ? eventSelect.start_date.substr(0, 10) : startDate"
                    />
                  </v-flex>

                  <v-flex
                    class="mt-2"
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isEndDate"
                  >
                    <p class="font-weight-medium my-0">วันที่สิ้นสุด</p>
                    <DatePicker
                      v-model="endDate"
                      ref="endDate"
                      :defaultDate="eventSelect.end_date ? eventSelect.end_date.substr(0, 10) : endDate"
                      :max="today"
                      @input="changeDate(utils.endDateChanged(startDate, endDate))"
                    />
                  </v-flex>
                  <v-flex
                    class="mt-2"
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isReportYear"
                  >
                    <p class="font-weight-medium my-0">ช่วงปี</p>
                    <v-select
                      v-model="yearReportSelect"
                      :items="yearReportItems"
                      flat
                      solo
                      hide-details
                      label="เลือกปี"
                      class="card-border"
                    />
                  </v-flex>
                  <v-flex
                    class="mt-2"
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isProvince"
                  >
                    <p class="font-weight-medium my-0">จังหวัด</p>
                    <v-select
                      v-model="provinceSelect"
                      :items="filterProvinceItems"
                      item-text="name"
                      item-value="id"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกจังหวัด"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex
                    class="mt-2"
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isVehicle"
                  >
                    <p class="font-weight-medium my-0">ประเภทพาหนะ</p>
                    <v-select
                      v-model="vehicleSelect"
                      :items="vehicleItems"
                      item-text="name"
                      item-value="id"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกพาหนะ"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex
                    class="mt-2"
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isAdmin && isReportDate"
                  >
                    <p class="font-weight-medium my-0">รายงาน ณ วันที่</p>
                    <DatePicker
                      v-model="reportDate"
                      ref="reportDate"
                      :min="startSearchDate"
                      :defaultDate="today"
                    />
                  </v-flex>
                  <v-flex
                    class="mt-2"
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isAdmin && isReportTime"
                  >
                    <p class="font-weight-medium my-0">เวลา</p>
                    <TimePicker v-model="reportTime" ref="reportTime" :defaultTime="nowtime" />
                  </v-flex>
                  <v-flex
                    class="mt-2"
                    :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']"
                    v-show="isDepartment"
                  >
                    <p class="font-weight-medium my-0">หน่วยงาน</p>
                    <v-select
                      v-model="departmentSelect"
                      :items="departmentItems"
                      item-text="description"
                      item-value="id"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกหน่วยงาน"
                      class="card-border"
                      flat
                      solo
                      :chips="departmentMultiple"
                      hide-details
                      :multiple="departmentMultiple"
                    >
                      <template v-slot:selection="{ item }" v-if="departmentMultiple">
                        <v-chip>
                          <span>{{ item.name_th }}</span>
                        </v-chip>
                        <!-- <spanf
                  v-if="index === 1"
                  class="grey--text caption"
                >(และอื่นๆ อีก {{ departmentSelect.length - 1 }} รายการ)</spanf> -->
                      </template>
                      <template v-slot:prepend-item v-if="departmentMultiple">
                        <v-list-item ripple @click="toggleSelectAllDepartment">
                          <v-list-item-action>
                            <v-icon :color="departmentSelect.length > 0 ? 'primary base' : ''">{{
                              departmentSelecticon
                            }}</v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>เลือกทั้งหมด</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>
        <v-card-actions class="ml-auto">
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">
            Close
          </v-btn>
          <v-btn class="white--text ml-2 px-4" color="#BA4438" @click="Getreportdetail(report)">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import DatePicker from '../global/DatePicker';
import TimePicker from '../global/TimePicker';

export default {
  name: 'Report',
  data: () => ({
    searchType: 'tabPeriod',
    yearSelect: '',
    eventSelect: '',
    startDate: '',
    endDate: '',
    reportDate: '',
    reportTime: '',
    provinceSelect: '',
    vehicleSelect: '',
    fesstdate: '',
    feseddate: '',
    yearItems: [],
    eventItems: [],
    provinceItems: [],
    vehicleItems: [],
    summaryReport: [],
    rangeReport: [],
    otherReport: [],
    yearReportSelect: '',
    today: null,
    nowtime: `${new Date().getHours()}:${new Date().getMinutes()}`,

    dialog: false,
    report: null,

    departmentSelect: [],
    departmentItems: [],
    departmentMultiple: true,

    isYear: true,
    isEvent: true,
    isDepartment: true,
    isStartDate: true,
    isEndDate: true,
    isProvince: true,
    isVehicle: true,
    isReportDate: true,
    isReportTime: true,
    isReportYear: false,
    isExatProvince: false
  }),
  components: {
    DatePicker,
    TimePicker
  },
  mounted() {
    this.today = this.utils.getLocalDate();
    this.init();
    this.getDepartmentLists();
  },
  watch: {
    searchType(value) {
      if (value == 'tabSeason' && this.eventSelect && this.eventSelect.start_date
        && (this.eventSelect.start_date.substr(0, 10) != this.startDate
        || this.eventSelect.end_date.substr(0, 10) != this.endDate)) {
          this.yearSelect = this.yearItems[0];
      }
    },
    yearSelect() {
      if (isNaN(this.yearSelect)) {
        this.eventItems = ['กำหนดเอง'];
        this.eventSelect = this.eventItems[0];
      }
      else {
        const scope = this;
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/${this.yearSelect -
          543}`;
        this.axios
          .get(url)
          .then(response => {
            scope.eventItems = response.data.data;
            scope.eventItems.unshift({
              name: 'เลือกทั้งปี',
              start_date: `${this.yearSelect - 543}-01-01 00:00:00`,
              end_date: `${this.yearSelect - 543}-12-31 00:00:00`
            });
            const defaultEvent = scope.eventItems.filter(event => event.isdefault);
            if (defaultEvent.length > 0) {
              scope.eventSelect = defaultEvent[0];
            }
            else {
              scope.eventSelect = scope.eventItems[0];
            }
          })
          .catch(function(error) {
            scope.eventItems = [];
            console.log(error);
          });
      }
    },
    eventSelect(val) {
      if ([this.$refs.startDate, this.$refs.endDate, this.eventSelect, this.eventSelect.start_date].indexOf(undefined) == -1) {
        this.$refs.startDate.setDefaultData(val.start_date.substr(0, 10));
        this.$refs.endDate.setDefaultData(val.end_date.substr(0, 10));
      }
    }
  },
  methods: {
    init() {
      this.get1stpanellist();
      this.get2ndpanellist();
      this.get3rdpanellist();
      this.getProvinceLists();
      this.getVehicleLists();
      this.getYearLists();
      // this.getEventLists();
    },
    getDefaultFestival() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/default`;
      this.axios.get(url).then(response => {
        const res = response.data.data;
        const defaultfes = res.filter(member => {
          return member.isdefault;
        })[0];
        scope.yearSelect = parseInt(defaultfes.end_date.split(' ')[0].substr(0, 4)) + 543;
      });
    },
    Getreportdetail(item) {
      this.dialog = false;
      const scoped = this;
      let url = `${process.env.VUE_APP_JASPER}/reports/reports/TRAMS_reports/`;
      if (item.report == 'accident_by_vehicle') {
        url = `${process.env.VUE_APP_SERVICE_API_URL}/service/list/`;
      }
      if (this.searchType == 'tabPeriod' || !this.eventSelect.start_date) {
        // period [url]/[ชื่อรายงานตามแต่ละลิงก์]?date_start=[วันที่เริ่มต้น]&date_end=[วันที่สิ้นสุด]&province=[id จังหวัด]&vehicle=[id ยานพาหนะ]&print_date=[วันรายงาน]&print_time=[เวลารายงาน]&year=[ปีของวันที่สิ้นสุด]
        let stdate = this.startDate.substring(0,10)
        let eddate = this.endDate.substring(0,10)
        if (item.yearReport) {
          stdate = this.yearReportSelect - 543 + '-01-01'
          eddate = this.yearReportSelect - 543 + '-12-31'
        }
        url += `${item.report}?date_start=${stdate}&date_end=${eddate}&province=${this.provinceSelect ||
          0}&vehicle=${this.vehicleSelect || 0}&print_date=${this.reportDate}&print_time=${
          this.reportTime
        }&year=${this.endDate.substr(0, 4)}&department=${this.departmentSelect.join()}`;
        if (item.report == 'accident_by_vehicle') {
          url += `&token=${localStorage.getItem('access_token')}`;
        }
        window.open(url);
      } else {
        // console.log(this.eventSelect);
        // festival [url]/[ชื่อรายงานตามแต่ละลิงก์]?date_start=[วันที่เริ่มต้น]&date_end=[วันที่สิ้นสุด]&name=[ชื่อเทศกาล]&year=[ปีของวันที่สิ้นสุด]
        let stdate = '';
        let eddate = '';
        if (this.eventSelect) {
          stdate = this.eventSelect.start_date.substr(0, 10);
          eddate = this.eventSelect.end_date.substr(0, 10);
        }
        url += `${item.fes}?date_start=${stdate}&date_end=${eddate}&name=${
          this.eventSelect.name
        }&year=${eddate.substr(0, 4)}&department=${this.departmentSelect.join()}&print_date=${this.utils.getLocalDate()}`;
        if (item.report == 'accident_by_vehicle') {
          url += `&token=${localStorage.getItem('access_token')}`;
        }
        window.open(url);
      }
    },
    openDialog(report) {
      this.report = report;
      this.dialog = true;
      this.clearDialog()
      this.isDepartment = report.report == 'accident_by_vehicle'
      this.isProvince = !report.disableProvince
      this.isVehicle = !report.disalbeVehicle
      this.isReportYear = report.yearReport
      this.isStartDate = !report.yearReport
      this.isEndDate = !report.yearReport
      this.isExatProvince = report.exatProvince != null
    },
    Gotopage(page) {
      if (page != null) {
        const routeData = this.$router.resolve({ name: page });
        window.open(routeData.href, '_blank');
      }
    },
    getYearLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/budget_year`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.yearItems = response.data.data.map(Number);
            scope.yearItems.unshift('กำหนดเอง');
            // scope.yearSelect = response.data.data[0];
            this.getDefaultFestival();
          }
        })
        .catch(function(error) {
          scope.yearItems = [];
          console.log(error);
        });
    },
    getEventLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/event`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.eventItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.eventItems = [];
          console.log(error);
        });
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            if (scope.provinceItems.length > 0)
              scope.provinceItems.unshift({ id: 0, name: 'เลือกทุกจังหวัด' });
          }
        })
        .catch(function(error) {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getVehicleLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/vehicle`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.vehicleItems = response.data.data;
            if (scope.vehicleItems.length > 0)
              scope.vehicleItems.unshift({ id: 0, name: 'เลือกทุกยานพาหนะ' });
          }
        })
        .catch(function(error) {
          scope.vehicleItems = [];
          console.log(error);
        });
    },
    get1stpanellist() {
      const list = {
        name: 'รายงานอุบัติเหตุบนโครงข่ายคมนาคม',
        icon: '',
        data: [
          {
            fes: 'year.pdf',
            report: 'year_s.pdf',
            name: 'รายงานฉบับสมบูรณ์',
            icon: '',
            disalbeVehicle: true,
          },
          {
            fes: 'accident_all.pdf',
            report: 'accident_all_s.pdf',
            name: 'รายงานเปรียบเทียบปีก่อน',
            icon: '',
            disalbeVehicle: true,
          },
          {
            fes: 'department_accident.pdf',
            report: 'department_accident_s.pdf',
            name: 'รายหน่วยงานผู้ดูแลโครงข่ายคมนาคม',
            icon: '',
            yearReport: true
          },
          {
            subheader: true,
            text: 'มิติพื้นที่'
          },
          {
            fes: 'region.pdf',
            report: 'region_s.pdf',
            name: 'รายภาค',
            icon: '',
            disableProvince: true,
            indent: true
          },
          {
            fes: 'province.pdf',
            report: 'province_s.pdf',
            name: 'รายจังหวัด',
            icon: '',
            disableProvince: true,
            indent: true
          },
          {
            fes: 'district.pdf',
            report: 'district_s.pdf',
            name: 'รายอำเภอ',
            icon: '',
            indent: true
          },
          {
            fes: 'sub_district.pdf',
            report: 'sub_district_s.pdf',
            name: 'รายตำบล',
            icon: '',
            indent: true
          }
        ]
      };
      const list2 = {
        name: '',
        icon: '',
        data: [
          {
            fes: 'train.pdf',
            report: 'train_s.pdf',
            name: 'รายงานอุบัติเหตุบนโครงข่ายรถไฟ',
            icon: '',
            disalbeVehicle: true
          }
        ]
      };
      const list3 = {
        name: '',
        icon: '',
        data: [
          {
            fes: 'accident_by_vehicle',
            report: 'accident_by_vehicle',
            name: 'Export ข้อมูลอุบัติเหตุบนโครงข่ายถนน',
            icon: '',
            disableProvince: true
          }
        ]
      };
      // this.summaryReport.push(list); //2026-11-04
      // this.summaryReport.push(list2); //2026-11-04
      this.summaryReport.push(list3);
    },
    get2ndpanellist() {
      const list = {
        name: 'รายงานอุบัติเหตุบนโครงข่ายถนน',
        icon: '',
        data: [
          {
            subheader: true,
            text: "สรุปภาพรวมเปรียบเทียบปีที่ผ่านมา"
          },
          {
            fes: 'accident5year_calendar_s_1.pdf',
            report: 'accident5year_calendar_s.pdf',
            name: 'เปรียบเทียบย้อนหลัง 5 ปี (ปีปฏิทิน)',
            icon: '',
            indent: true
          },
          {
            fes: 'calendar.pdf',
            report: 'calendar_s.pdf',
            name: 'เปรียบเทียบรายไตรมาส (ปีปฏิทิน)',
            icon: '',
            yearReport: true,
            indent: true
          },
          {
            fes: 'budget_year.pdf',
            report: 'budget_year_s.pdf',
            name: 'เปรียบเทียบรายไตรมาส (ปีงบประมาณ)',
            icon: '',
            yearReport: true,
            indent: true
          },
          
          {
            fes: 'accident_road.pdf',
            report: 'accident_road_s.pdf',
            name: 'เปรียบเทียบรายวัน',
            icon: '',
            disalbeVehicle: true,
            indent: true
          },
          {
            subheader: true,
            text: "มิติโครงสร้างพื้นฐาน/พื้นที่"
          },
          {
            fes: 'accident_pm.pdf',
            report: 'accident_pm_s.pdf',
            name: 'อุบัติเหตุใหญ่ตามนิยาม ปภ.',
            icon: '',
            indent: true
          },
          {
            fes: 'motorway7_9.pdf',
            report: 'motorway7_9_s.pdf',
            name: 'อุบัติเหตุบนทางหลวงพิเศษ และทางด่วน',
            icon: '',
            exatProvince: true,
            indent: true
          },
          {
            fes: 'route.pdf',
            report: 'route_s.pdf',
            name: 'สายทางที่เกิดอุบัติเหตุสูงสุด',
            icon: '',
            indent: true
          },
          {
            fes: 'topprovince.pdf',
            report: 'topprovince_s.pdf',
            name: 'จังหวัดที่เกิดอุบัติเหตุสูงสุด',
            icon: '',
            disableProvince: true,
            indent: true
          },
          {
            fes: 'area.pdf',
            report: 'area_s.pdf',
            name: 'ลักษณะบริเวณที่เกิดเหตุ',
            icon: '',
            indent: true
          },
          // {
          //   fes: 'transport_type.pdf',
          //   report: 'transport_type_s.pdf',
          //   name: 'สายทาง กิโลเมตรที่เกิดเหตุ',
          //   icon: ''
          // },
          {
            fes: 'surface.pdf',
            report: 'surface_s.pdf',
            name: 'ชนิดพื้นผิว/ผิวจราจร',
            icon: '',
            indent: true
          }
        ]
      };
      // const list2 = {
      //   name: '',
      //   icon: '',
      //   data: [
      //     {
      //       fes: 'driver.pdf',
      //       report: 'driver_s.pdf',
      //       name: 'ผู้ขับขี่หรือผู้ใช้ถนน',
      //       icon: ''
      //     }
      //   ]
      // };
      // const list3 = {
      //   name: 'รายงานสรุปสถานการณ์อุบัติเหตุ',
      //   icon: '',
      //   link: 'report-executive',
      //   data: []
      // };
      // this.rangeReport.push(list); //2026-11-04
      // this.rangeReport.push(list2);
      // this.rangeReport.push(list3);
    },
    get3rdpanellist() {
      const list = {
        name: 'รายงานอุบัติเหตุบนโครงข่ายถนน',
        icon: '',
        data: [
          {
            subheader: true,
            text: "มิติผู้ขับขี่/ผู้ใช้ถนน"
          },
          {
            fes: 'cause.pdf',
            report: 'cause_s.pdf',
            name: 'มูลเหตุสันนิษฐาน',
            icon: '',
            indent: true
          },
          // {
          //   fes: 'summary.pdf',
          //   report: 'summary_s.pdf',
          //   name: 'พฤติกรรมเสี่ยง',
          //   icon: '',
          //   disalbeVehicle: true,
          //   indent: true
          // },
          {
            fes: 'class.pdf',
            report: 'class_s.pdf',
            name: 'เพศและช่วงอายุ',
            icon: '',
            indent: true
          },
          {
            subheader: true,
            text: "มิติประเภทยานพาหนะ"
          },
          {
            fes: 'vehicle.pdf',
            report: 'vehicle_s.pdf',
            name: 'ประเภทยานพาหนะ',
            icon: '',
            disalbeVehicle: true,
            indent: true
          },
          {
            subheader: true,
            text: "มิติสภาพแวดล้อมภายนอก"
          },
          // {
          //   fes: 'accident5year_budget_year.pdf',
          //   report: 'accident5year_budget_year_s.pdf',
          //   name: 'อุบัติเหตุรายปี (ปีงบประมาณ)',
          //   icon: ''
          // },
          {
            fes: 'weather.pdf',
            report: 'weather_s.pdf',
            name: 'สภาพอากาศ',
            icon: '',
            indent: true
          },
          {
            fes: 'time.pdf',
            report: 'time_s.pdf',
            name: 'ช่วงเวลา',
            icon: '',
            indent: true
          },
          // {
          //   fes: 'daily.pdf',
          //   report: 'daily_s.pdf',
          //   name: 'อุบัติเหตุภาพรวมเทียบรายวัน',
          //   icon: ''
          // }
        ]
      };
      // const list2 = {
      //   name: '',
      //   icon: '',
      //   data: [
      //     {
      //       fes: 'train.pdf',
      //       report: 'train_s.pdf',
      //       name: 'รายงานอุบัติเหตุบนโครงข่ายรถไฟ',
      //       icon: ''
      //     }
      //   ]
      // };
      // if (localStorage.getItem('role')) {
        // list2.data.push({
        //   fes: 'accident_by_vehicle',
        //   report: 'accident_by_vehicle',
        //   name: 'Export ข้อมูลอุบัติเหตุบนโครงข่ายถนน',
        //   icon: ''
        // });
      // }
      // this.otherReport.push(list); //2026-11-04
      // this.otherReport.push(list2);
    },
    changeDate(period) {
      if (period) {
        if (period.startDate != this.startDate) {
          this.$refs.startDate.setDefaultData(period.startDate);
        }
        if (period.endDate != this.endDate) {
          this.$refs.endDate.setDefaultData(period.endDate);
        }
      }
    },
    getDepartmentLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/department`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.departmentItems = response.data.data;
            if (scope.departmentItems.length > 0 && !scope.departmentMultiple)
              scope.departmentItems.unshift({
                id: 0,
                name: '',
                description: 'เลือกทุกหน่วยงาน'
              });
            // this.search();
          }
        })
        .catch(function(error) {
          scope.departmentItems = [];
          console.log(error);
        });
    },
    toggleSelectAllDepartment() {
      this.$nextTick(() => {
        if (this.selectAlldepartment) {
          this.departmentSelect = [];
        } else {
          this.departmentSelect = [];
          this.departmentItems.forEach(element => {
            this.departmentSelect.push(element.id);
          });
        }
      });
    },
    clearDialog() {
      let now = new Date()
      this.reportTime = `${now.getHours()}:${now.getMinutes()}`;
      this.yearReportSelect = "";
      this.provinceSelect = "";
      this.vehicleSelect = "";
    }
  },
  computed: {
    isAdmin() {
      return ['ADMIN', 'SYSTEM'].indexOf(localStorage.getItem('role')) != -1;
    },
    selectAlldepartment() {
      return this.departmentSelect.length === this.departmentItems.length;
    },
    selectSomedepartment() {
      return this.departmentSelect.length > 0 && !this.selectAlldepartment;
    },
    departmentSelecticon() {
      if (this.selectAlldepartment) return 'mdi-close-box';
      if (this.selectSomedepartment) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    yearReportItems() {
      let thisyear = new Date().getFullYear()
      let yearArr = [] 
      for (let index = thisyear; index > thisyear - 20; index--) {
        yearArr.push(index + 543)
      }
      return yearArr
    },
    filterProvinceItems() {
      if (this.isExatProvince) {
        return this.provinceItems.filter(a => a.is_exat || !a.id)
      }
      return this.provinceItems
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 20px;
  box-shadow: none;
  border: 1px solid #cfcfcf;
}

.v-card-title {
  color: #131313;
  background: #ededed;
  font-size: 16px;
  padding: 4px 16px;
}

.v-card-text {
  padding: 0px 4px 0px 16px;
}

.item {
  padding: 0;
  min-height: auto;
}

.v-list-item__content {
  padding: 6px 0;
}
</style>

